"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  IMPORT_DATA: "@@crm/import-data",
  VALIDATE_MAPPING: "@@crm/validate-mapping",
  IMPORT_MAPPING: "@@crm/import-mapping",
  DOWNLOAD_MAPPING: "@@crm/download-mapping",
  DOWNLOAD_MAPPING_CUSTOM_COLUMN: "@@crm/download-mapping-custom-column",
  SAVE_BULK: "@@crm/save-bulk",
  TEST_BULK: "@@crm/test-bulk",
  LIST: "@@crm/list",
  GET: "@@crm/get",
  UPDATE: "@@crm/update",
  DELETE: "@@crm/delete",
  PAUSE: "@@crm/pause",
  DISCONNECT: "@@crm/disconnect",
  SUCCESS: "@@crm/success",
  ERROR: "@@crm/error",
  RESET: "@@crm/reset"
};
exports.actionTypes = actionTypes;